<template>
  <div class="element-input element-spread-multiple-select">
    <div class="label">{{ label }}</div>
    <ul>
      <li :class="{ on: value == item.value }" v-if="validate(item)" 
      v-for="item in items" @click="selectItem( item )">{{ item.label }}</li>
    </ul>
    <div class="error" v-if="error">{{ error }}</div>
    <slot />
    
    <div class="form-item-caution">{{cautiontext}}</div>
  </div>
</template>
<script>
export default {
  data(){
    return {
      cautiontext: "운전자 범위를 선택하세요."
    }
  },
  props: [ "value", "label", "error", "items", "tag", "usage", "carType" ],
  computed: {
    isMultiple(){
      return this.items && this.items.length > 1;
    },
    model: {
      get(){
        return this.value;
      },
      set( value ){
        this.$emit( "input", value );
      }
    }
  },
  created(){
    /*this.$watch( "isMultiple", isMultiple => {
      if( isMultiple && !Array.isArray( this.value ) ){
        this.$emit( "input", []);
      };
    }, { immediate: true });*/
  },
  methods: {
    validate( item ){
      if(this.usage === '법인'){
        if(this.carType === '승용차'){
          return this.usage == item.userCategory
        }
        else{
          return this.usage == item.userCategory && !item.carCategory
        }
      }
      else{
        return this.usage == item.userCategory
      }
    },
    selectItem( item ){
      this.cautiontext = item.description
      this.$emit( "input", item.value ); return;
      if( this.isMultiple ){
        if( this.item.value.indexOf( item.value ) >= 0 ){
          this.$emit( "input", this.item.value.filter( o => o != item.value ) );
        }else{
          this.$emit( "input", this.item.value.concat( [ item.value ] ) );
        };
      }else{
        if( this.item.value ){
          this.$emit( "input", false );
        }else{
          this.$emit( "input", true );
        };
      };
    }
  }
}
</script>
